import React from "react";
import { ServicesContainer, ServicesH1, ServicesWrapper, ServicesCard, ServicesIcon, ServicesH2, ServicesP } from "./ServicesElements";
import Icon1 from "../../images/Wordpress.jpg"
import Icon2 from "../../images/soft.jpg"
import Icon3 from "../../images/mobile.png"
import Icon4 from "../../images/seo.jpg"
import Icon5 from "../../images/logo.jpg"
import Icon6 from "../../images/ui.jpg"
import Icon7 from "../../images/content.jpeg"

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Our Services</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>WordPress</ServicesH2>
          <ServicesP>
            At our company, we specialize in WordPress development and provide comprehensive solutions for creating and managing websites.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Software Development</ServicesH2>
          <ServicesP>
            As a software development company, we specialize in creating tailored software solutions to meet your unique business requirements.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>Mobile App Development</ServicesH2>
          <ServicesP>
            We are dedicated to crafting exceptional mobile applications that engage and delight users. Our mobile app development services cover iOS and Android platforms, ensuring a seamless user experience across devices.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon4} />
          <ServicesH2>SEO </ServicesH2>
          <ServicesP>
            Our company specializes in search engine optimization (SEO) to help businesses improve their online visibility and attract organic traffic.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon5} />
          <ServicesH2>Branding (Logo, Brochure):  </ServicesH2>
          <ServicesP>
            Our team of experienced designers combines artistic creativity with strategic thinking to create unique and impactful logos.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon6} />
          <ServicesH2>UI/UX</ServicesH2>
          <ServicesP>
            Our company is dedicated to delivering outstanding user experiences through intuitive and visually appealing user interfaces.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon7} />
          <ServicesH2>Content Writing </ServicesH2>
          <ServicesP>
            We provide professional content writing services to help you communicate your brand's message effectively.


          </ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;